const SDK_VERSION = '7.57.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
